module.exports = __webpack_public_path__ + "img/report-4.7315af91.jpg";